export enum RegisterType {
  SALE = 'sold',
  RETIRED = 'retired',
  IMPAIRED = 'impaired',
  DIVIDED = 'divided',
}

// Values double as the URL hash of the asset detail tabs, so keep them readable.
export enum AssetDetailTabType {
  INFORMATION = 'information',
  AMORTIZATION = 'amortization',
  EVENT_HISTORY = 'event-history',
}
